<!-- Revised on 2024/12/11 by mnavarro -->
<template>
    <div class="pb-0 card-header">
        <div class="d-lg-flex">
            <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
            </div>
            <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                    <!-- Edit actions (Add, clone and edit) -->
                    
                    <!-- Activate and deactivate actions -->
                    
                    <!-- Recover and delete actions -->
                    
                    <!-- Interactions with database (filters and reload) -->
                    <StockProductWarehouseFilter v-if="$PickoVersion.isV1()" :filter-warehouse-selected="listFilters?.warehouse" @stock-product-warehouse-filter-change="stockProductWarehouseFilterChange"/>
                    <StockProductWarehouseFilterV2 v-if="$PickoVersion.isV2()" :filter-warehouse-selected="listFilters?.warehouse" @stock-product-warehouse-filter-change="stockProductWarehouseFilterChange"/>
                    <StockProductStatusFilter :filter-status-selected="listFilters?.status" @stock-product-status-filter-change="stockProductStatusFilterChange"/>
                    <Button :title="$t('key_export')" color="primary" variant="outline" class="ms-2" data-type="csv" @click="exportData">
                        <i class="fa-solid fa-download me-1" aria-hidden="true"></i>
                    </Button>
                    <ReloadButton id="reload" :title="$t('key_userListTableHeader_button_reload_user')" :enable-reload="enableReload" @reload-page="reloadPage"/>
                </div>
            </div>
            <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                    <!-- Search space -->
                    <Searchbox :enable-search="enableSearch" :list-filters="listFilters" @search-change="searchChange"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Button from "./../../../../generic_components/Button.vue";
    import ReloadButton from "./../../../../generic_components/ReloadButton.vue";
    import Searchbox from "./../../../../generic_components/Searchbox.vue";
    import StockProductStatusFilter from "./../filters/StockProductStatusFilter.vue";
    import StockProductWarehouseFilter from "./../filters/StockProductWarehouseFilter.vue"
    import StockProductWarehouseFilterV2 from "./../filters/StockProductWarehouseFilterV2.vue"

    export default {
        name: "WarehouseListTableHeader",
        components: {
            Button,
            ReloadButton,
            Searchbox,
            StockProductStatusFilter,
            StockProductWarehouseFilter,
            StockProductWarehouseFilterV2,
        },
        props: {
            title: {
                type: String,
                default: ""
            },
            description: {
                type: String,
                default: ""
            },
            enableReload: {
                type: Boolean,
                default: true
            },
            enableSearch: {
                type: Boolean,
                default: true
            },
            selectedIds: {
                type: Array,
                default: () => []
            },
            listFilters: {
                type: Object,
                default: () => ({})
            }
        },
        emits: ['search-change', 'reload-page', 'export-data', 'stock-product-status-filter-change', 'stock-product-warehouse-filter-change'],
        methods: {
            reloadPage() {
                this.$emit("reload-page");
            },
            exportData() {
                this.$emit("export-data");
            },
            searchChange(searchValue) {
                this.$emit("search-change", searchValue);
            },
            stockProductStatusFilterChange(selectedStatus) {
                this.$emit("stock-product-status-filter-change", selectedStatus);
            },
            stockProductWarehouseFilterChange(selectedWarehouse) {
                this.$emit("stock-product-warehouse-filter-change", selectedWarehouse);
            }
        }
    }

</script>